import { gql } from 'apollo-angular';
import { attachedFileFragment } from '../upload/upload.fragments';

export const learningResourceFileMinimal = gql`
  fragment LearningResourceFileMinimal on LearningResourceFile {
    id
    title
    description
    content {
      ...AttachedFile
    }
    image {
      id
      url
    }
  }
  ${attachedFileFragment}
`;
